import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import { DatePipe } from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';
import {GameNoteInterface} from '@models';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {FirebaseService} from "@core/services/firebase.service";
import {UserService} from "@services";
import {v4 as uuid} from 'uuid';
import {ImagePlaceholderComponent} from "@shared/components";

@Component({
    selector: 'app-game-notes-modal',
    imports: [
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    ReactiveFormsModule,
    DatePipe,
    ImagePlaceholderComponent
],
    templateUrl: './game-notes-modal.component.html',
    styleUrls: ['./game-notes-modal.component.scss']
})
export class GameNotesModalComponent implements OnInit {
  public noteForm!: FormGroup;
  public gameNotes: GameNoteInterface[] = []
  @ViewChild('scrollContainer') private _scrollContainer: ElementRef;

  constructor(
    private _fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { code: string },
    private _firebaseService: FirebaseService,
    private userService: UserService,
  ) {
  }

  ngOnInit() {
    this._initForm();
    this._getGameNotes()
  }

  private _getGameNotes() {
    this._firebaseService.getGameNote(this.data.code)
      .subscribe(value => {
        if (!value) return
        this.gameNotes = value.gameNotes
        this._scrollToBottom()
      })
  }

  private _initForm(): void {
    this.noteForm = this._fb.group({
      note: ''
    });
  }

  public onSave(): void {
    if (!this.data.code || !this.noteForm.value.note) return
    let note: GameNoteInterface = {
      id: uuid(),
      user: this.userService.user,
      note: this.noteForm.value.note,
      createDate: new Date().toISOString(),
    }
    this.noteForm.reset()
    this._firebaseService.onGameNoteChange([...this.gameNotes, note], this.data.code.toString())
      .subscribe(value => {
        this.gameNotes = value
        this._scrollToBottom()
      })
  }

  public deleteNote(note: GameNoteInterface) {
    this.gameNotes = this.gameNotes.filter(value => value.id !== note.id)
    this._firebaseService.onGameNoteChange(this.gameNotes, this.data.code.toString())
      .subscribe(value => this.gameNotes = value)
  }

  private _scrollToBottom(): void {
    try {
      setTimeout(() => {
        this._scrollContainer.nativeElement.scrollTop = this._scrollContainer.nativeElement.scrollHeight;
      }, 0)


    } catch (err) {
      console.log(err)
    }
  }
}
